import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useSmoothScroll = (options = {}) => {
  const location = useLocation();
  const { behavior = 'smooth', block = 'start' } = options;

  useEffect(() => {
    // Scroll to top on new page load
    if (location.pathname !== location.state?.from) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    // Handle anchor links
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior,
            block
          });
        }
      }
    };

    // Initial check for hash
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [location.pathname, behavior, block]);
}; 